<template>
    <main v-if="ll">

        <div class="ms-banner aname" ref="home">
            <div class="ms-container">
                <div class="ms-banner__wrap">
                    <div class="ms-banner__text">
                        <h1 data-vl="10153" v-html="ll.i10153||'My Print Screen Free screen capture software'"></h1>
                        <p data-vl="10154" v-html="ll.i10154||''"></p>
                        <ul class="ms-counter">
                            <li class="ms-counter__item">
                                <h3 data-vl="10155">{{ll.i10155||'Since 2013'}}</h3>
                                <p data-vl="10156">{{ll.i10156||'The best Windows Print Screen alternative'}}</p>
                            </li>
                            <li class="ms-counter__item">
                                <h3 data-vl="10157">{{ll.i10157||'3 Million +'}}</h3>
                                <p data-vl="10158">{{ll.i10158||'Screenshots taken'}}</p>
                            </li>
                        </ul>
                        <div class="ms-counter__text-btn">
                            <a :href="$root.downloadLink" :download="$root.downloadName" class="btn-green">
                                <span data-vh="10159" v-html="ll.i10159||''"></span>
                                <img src="img/arrow-download.svg" alt="">
                            </a>
                        </div>

                    </div>
                    <div class="ms-banner__img">
                        <img src="img/img-banner.png" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="ms-benefits">
            <div class="ms-container">
                <div class="ms-title">
                    <h2 data-vl="10161">{{ll.i10161||'Features and Benefits'}}</h2>
                </div>
                <div class="ms-benefits__wrap">
                    <div class="ms-benefits__item">
                        <div class="ms-benefits__item-icon">
                            <img src="img/deadline-icon.svg" alt="deadline">
                        </div>
                        <div class="ms-benefits__item-content">
                            <h3 data-vl="10162">{{ll.i10162||'Lightning-fast & Easy to use'}}</h3>
                            <p data-vl="10163">{{ll.i10163||''}}</p>
                        </div>
                    </div>
                    <div class="ms-benefits__item">
                        <div class="ms-benefits__item-icon">
                            <img src="img/file-icon.svg" alt="file-">
                        </div>
                        <div class="ms-benefits__item-content">
                            <h3 data-vl="10164">{{ll.i10164||'Save & Share'}}</h3>
                            <p data-vl="10165">{{ll.i10165||''}}</p>
                        </div>
                    </div>
                    <div class="ms-benefits__item">
                        <div class="ms-benefits__item-icon">
                            <img src="img/photo-icon.svg" alt="file-">
                        </div>
                        <div class="ms-benefits__item-content">
                            <h3 data-vl="10166">{{ll.i10166||'No-limit capturing'}}</h3>
                            <p data-vl="10167">{{ll.i10167||''}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="ms-questions aname" ref="faq">
            <div class="ms-container">
                <div class="ms-title">
                    <h2 data-vl="10168">{{ll.i10168||'Frequently Asked Questions'}} </h2>
                </div>

                <div class="ms-accordion">
                    <template v-for="(row, index) in questionArr">
                        <div v-if="ll['i'+row[0]]" :key="index" class="ms-accordion__item" :class="[question['a'+index] ? 'active':'']">
                            <p class="a-btn" @click="showQuestion(index)" :data-vl="row[0]"><strong>{{index+1}}.</strong> {{ll['i'+row[0]]||''}}<span></span></p>
                            <div class="a-panel" :data-vh="row[1]" v-html="ll['i'+row[1]]||''"></div>
                        </div>
                    </template>
                    <!--<div class="ms-accordion__item">
                        <p class="a-btn"><strong>2.</strong> When I will reach Google TOP-10? <span></span></p>
                        <div class="a-panel">
                            <p>FullSEO prices depend on many factors: website quality and authority.</p>
                            <p>Semalt offers affordable solutions for all kind of businesses.</p>
                        </div>
                    </div>-->
                </div>
            </div>
        </div>


        <div class="ms-news">
            <div class="ms-container">
                <div class="ms-title">
                    <h2 class="text-center" data-vl="10195">{{ll.i10195||'Lates news'}}</h2>
                </div>
                <div class="ms-news__wrap">
                    <div class="ms-news__item">
                        <img src="img/safe.svg" alt="">
                    </div>
                    <div class="ms-news__item">
                        <img src="img/new-version.svg" alt="">
                    </div>
                    <div class="ms-news__item">
                        <img src="img/lang.svg" alt="">
                    </div>
                </div>
            </div>
        </div>

        <div class="aname" ref="contact">
            <contact-us></contact-us>
        </div>

        <div class="ms-address">
            <div class="ms-address__text">
                <p data-vl="10196" v-html="vv(ll.i10196)"></p>
            </div>
        </div>
    </main>
</template>

<script>
    import ContactUs from "./ContactUs"
    export default {
        name: "PageScreen",
        components:{
            ContactUs
        },
        computed:{
            ll(){
                return this.$root.ll;
            }
        },
        data: function() {
            return{
                question: {
                    a0:true,a1:false,a2:false,a3:false,a4:false,a5:false,a6:false,a7:false,a8:false,a9:false,a10:false,
                    a11:false,a12:false,a13:false,a14:false,a15:false,a16:false,a17:false,a18:false,a19:false,a20:false,
                    a21:false,a22:false,a23:false,a24:false,a25:false,a26:false,a27:false,a28:false,a29:false,a30:false
                },
                questionArr:[
                    [10169,10170],[10171,10172],[10173,10174],[10175,10176],[10177,10178],
                    [10179,10180],[10181,10182],[10183,10184],[10185,10186],[10187,10188],
                    [10189,10190],[10191,10192],[10193,10194],[10211,10212],[10213,10214],
                    [10215,10216],[10217,10218],/*[10219,10220],*/[10221,10222],[10223,10224],
                    [10225,10226],[10227,10228],[10229,10230],[10231,10232]
                ]
            }
        },
        methods: {
            async init(){
                if(this.$route.hash){
                    this.linkHash(this.$route.hash.replace('#',''));
                }
            },
            showQuestion(val){
                val = parseInt(val);
                if(typeof this.question['a'+val] !== 'undefined') this.question['a'+val] = !this.question['a'+val];
            },
            linkHash(to){
                if(to){
                    to = to.replace('#','');
                    let slide = this.$refs[to];
                    if(slide){
                        let top = window.scrollY + slide.getBoundingClientRect().y;
                        window.scrollTo(0, top);
                    }
                }
                else {
                    window.scrollTo(0, 0);
                }
            },
            vv(text){
                return text.replace(/\n/g,"<br />");
            }
        },
        mounted(){
            this.init();
        },
        watch:{
            '$route.hash'(to){
                this.linkHash(to);
            }
        }
    }
</script>

